import ViewOnlyLabel from './label/viewOnlyLabel';
import ViewOnlyPopoverContainer from './popover/viewOnlyPopoverContainer';

export default function ViewOnlyDisclaimer() {
  return (
    <>
      <ViewOnlyLabel />
      <ViewOnlyPopoverContainer />
    </>
  );
}
